/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantHealthActiveChats } from './TenantHealthActiveChats';
import {
    TenantHealthActiveChatsFromJSON,
    TenantHealthActiveChatsFromJSONTyped,
    TenantHealthActiveChatsToJSON,
} from './TenantHealthActiveChats';
import type { TenantHealthEmailSuppressions } from './TenantHealthEmailSuppressions';
import {
    TenantHealthEmailSuppressionsFromJSON,
    TenantHealthEmailSuppressionsFromJSONTyped,
    TenantHealthEmailSuppressionsToJSON,
} from './TenantHealthEmailSuppressions';
import type { TenantHealthFax } from './TenantHealthFax';
import {
    TenantHealthFaxFromJSON,
    TenantHealthFaxFromJSONTyped,
    TenantHealthFaxToJSON,
} from './TenantHealthFax';
import type { TenantHealthHelpdesk } from './TenantHealthHelpdesk';
import {
    TenantHealthHelpdeskFromJSON,
    TenantHealthHelpdeskFromJSONTyped,
    TenantHealthHelpdeskToJSON,
} from './TenantHealthHelpdesk';
import type { TenantHealthHl7 } from './TenantHealthHl7';
import {
    TenantHealthHl7FromJSON,
    TenantHealthHl7FromJSONTyped,
    TenantHealthHl7ToJSON,
} from './TenantHealthHl7';
import type { TenantHealthNotifications } from './TenantHealthNotifications';
import {
    TenantHealthNotificationsFromJSON,
    TenantHealthNotificationsFromJSONTyped,
    TenantHealthNotificationsToJSON,
} from './TenantHealthNotifications';
import type { TenantHealthScheduledEvents } from './TenantHealthScheduledEvents';
import {
    TenantHealthScheduledEventsFromJSON,
    TenantHealthScheduledEventsFromJSONTyped,
    TenantHealthScheduledEventsToJSON,
} from './TenantHealthScheduledEvents';
import type { TenantHealthSesEmail } from './TenantHealthSesEmail';
import {
    TenantHealthSesEmailFromJSON,
    TenantHealthSesEmailFromJSONTyped,
    TenantHealthSesEmailToJSON,
} from './TenantHealthSesEmail';
import type { TenantHealthSms } from './TenantHealthSms';
import {
    TenantHealthSmsFromJSON,
    TenantHealthSmsFromJSONTyped,
    TenantHealthSmsToJSON,
} from './TenantHealthSms';

/**
 * 
 * @export
 * @interface TenantHealthStats
 */
export interface TenantHealthStats {
    /**
     * 
     * @type {TenantHealthEmailSuppressions}
     * @memberof TenantHealthStats
     */
    email_suppressions?: TenantHealthEmailSuppressions;
    /**
     * 
     * @type {TenantHealthSesEmail}
     * @memberof TenantHealthStats
     */
    ses_email?: TenantHealthSesEmail;
    /**
     * 
     * @type {TenantHealthHelpdesk}
     * @memberof TenantHealthStats
     */
    helpdesk?: TenantHealthHelpdesk;
    /**
     * 
     * @type {TenantHealthFax}
     * @memberof TenantHealthStats
     */
    fax?: TenantHealthFax;
    /**
     * 
     * @type {TenantHealthScheduledEvents}
     * @memberof TenantHealthStats
     */
    scheduled_events?: TenantHealthScheduledEvents;
    /**
     * 
     * @type {TenantHealthActiveChats}
     * @memberof TenantHealthStats
     */
    active_chats?: TenantHealthActiveChats;
    /**
     * 
     * @type {TenantHealthNotifications}
     * @memberof TenantHealthStats
     */
    notifications?: TenantHealthNotifications;
    /**
     * 
     * @type {TenantHealthSms}
     * @memberof TenantHealthStats
     */
    sms?: TenantHealthSms;
    /**
     * 
     * @type {TenantHealthHl7}
     * @memberof TenantHealthStats
     */
    hl7?: TenantHealthHl7;
}

/**
 * Check if a given object implements the TenantHealthStats interface.
 */
export function instanceOfTenantHealthStats(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthStatsFromJSON(json: any): TenantHealthStats {
    return TenantHealthStatsFromJSONTyped(json, false);
}

export function TenantHealthStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email_suppressions': !exists(json, 'email_suppressions') ? undefined : TenantHealthEmailSuppressionsFromJSON(json['email_suppressions']),
        'ses_email': !exists(json, 'ses_email') ? undefined : TenantHealthSesEmailFromJSON(json['ses_email']),
        'helpdesk': !exists(json, 'helpdesk') ? undefined : TenantHealthHelpdeskFromJSON(json['helpdesk']),
        'fax': !exists(json, 'fax') ? undefined : TenantHealthFaxFromJSON(json['fax']),
        'scheduled_events': !exists(json, 'scheduled_events') ? undefined : TenantHealthScheduledEventsFromJSON(json['scheduled_events']),
        'active_chats': !exists(json, 'active_chats') ? undefined : TenantHealthActiveChatsFromJSON(json['active_chats']),
        'notifications': !exists(json, 'notifications') ? undefined : TenantHealthNotificationsFromJSON(json['notifications']),
        'sms': !exists(json, 'sms') ? undefined : TenantHealthSmsFromJSON(json['sms']),
        'hl7': !exists(json, 'hl7') ? undefined : TenantHealthHl7FromJSON(json['hl7']),
    };
}

export function TenantHealthStatsToJSON(value?: TenantHealthStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email_suppressions': TenantHealthEmailSuppressionsToJSON(value.email_suppressions),
        'ses_email': TenantHealthSesEmailToJSON(value.ses_email),
        'helpdesk': TenantHealthHelpdeskToJSON(value.helpdesk),
        'fax': TenantHealthFaxToJSON(value.fax),
        'scheduled_events': TenantHealthScheduledEventsToJSON(value.scheduled_events),
        'active_chats': TenantHealthActiveChatsToJSON(value.active_chats),
        'notifications': TenantHealthNotificationsToJSON(value.notifications),
        'sms': TenantHealthSmsToJSON(value.sms),
        'hl7': TenantHealthHl7ToJSON(value.hl7),
    };
}

